import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const ActionsBar: FCX = ({
    children,
    style,
	className,
}) => {
    return (
        <div
            className={
				cn(
					"ActionsBar",
					"appears-top",
					className,
				)
            }
            style={style}
        >
            {children}
        </div>
    );
};

export default ActionsBar;